import type { useTranslations } from "@jti/ui/providers/useTranslations";

export const getTierDescription = ({
  isSecured,
  pointsToNextTier,
  nextTierName,
  currentTier,
  translateFunction,
  pointsToKeepTier,
}: {
  isSecured: boolean;
  currentTier: string;
  pointsToNextTier: number;
  nextTierName: string;
  translateFunction: typeof useTranslations.prototype.__;
  pointsToKeepTier: number;
}) => {
  const translationKeyAffix = isSecured ? "Secured" : "NotSecured";
  const currentTierLowerCase = currentTier.toLowerCase();

  if (currentTierLowerCase === "silver") {
    return translateFunction("loyalty.pointsStatus.bottomItemDetailsBarRightTitle.silverTier", [
      pointsToNextTier,
      nextTierName,
    ]);
  }

  if (currentTierLowerCase === "gold") {
    const interpolationPayload = isSecured
      ? [currentTier, pointsToNextTier, nextTierName]
      : [currentTier, pointsToKeepTier];

    return translateFunction(
      `loyalty.pointsStatus.bottomItemDetailsBarRightTitle.goldTier${translationKeyAffix}`,
      interpolationPayload
    );
  }

  if (currentTierLowerCase === "black") {
    const interpolationPayload = isSecured ? [currentTier] : [pointsToKeepTier, currentTier];
    return translateFunction(
      `loyalty.pointsStatus.bottomItemDetailsBarRightTitle.blackTier${translationKeyAffix}`,
      interpolationPayload
    );
  }
};
